import styled from 'styled-components';
import cssKit from '../../css';

export const StyledThankYouModal = styled.div`
  max-width: 500px;
`;

export const StyledThankYouTitle = styled.span`
  font-family: ${cssKit.fonts.bold};
  font-size: 1.5rem;
  padding-bottom: 20px;
  width: 100%;
  border-bottom: 1px dotted #e1e1e1;
  display:inline-block;
`;

export const StyledThankYouContent = styled.div`
  font-family: ${cssKit.fonts.regular};
  font-size: .85rem;
  padding-bottom: .75rem;
  padding-top: 1rem;
  display: inline-block;
`;

export const StyledFormCTAWrapper = styled.div`
  max-width: 250px;
  display: inline-block;
  padding: 10px;
`;



/** WEBPACK FOOTER **
 ** ./src/components/FormThankYou/styles.js
 **/